<template>
    <div class="locataion-box pt-16 pt-lg-30 border-top border-color-light">
        <h5 class="tit-txt font-weight-bold color-point mb-6 mb-lg-12">{{tit}}</h5>
        <div class="mb-6 mb-lg-14">
            <div class="d-flex page-text mb-2 mb-lg-4">
                <p class="font-weight-bold min-w-40px mr-lg-8">
                    주소
                </p>
                <p class="color-grey" data-aos="fade-right">
                    {{address}}
                </p>
            </div>
            <div class="d-flex page-text--sm">
                <p class="font-weight-bold min-w-40px mr-lg-8">
                    전화
                </p>
                <a :href="'tel:'+tel" class="d-block color-grey" data-aos="fade-right">
                    {{tel}}
                </a>
            </div>
        </div>
        <div class="map" data-aos="fade-up">
            <img :src="mapImage" class="w-100">
            <div class="link mt-2 mt-lg-0">
                <arrow-btn tit="지도보기" color="primary" :link="link" type="href"></arrow-btn>
            </div>
        </div>
    </div>
</template>

<script>

import ArrowBtn from "@/components/client/sub/arrow-btn.vue";

export default{
    props : {
        tit : {type :String, default : ""},
        address : {type :String, default : ""},
        tel : {type :String, default : ""},
        mapImage : {type :String, default : ""},
        link : {type :String, default : ""},
    },
    components: {
        ArrowBtn
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: true,
    //                 offset: 240,
    //                 duration: 500,
    //                 delay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.locataion-box .map{
    overflow: hidden;
    position: relative;
}

@media(min-width:1024px){
    .locataion-box .map::after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        transition: all ease .5s;
        opacity: 0;
    }
    .locataion-box .map .link{
        z-index: 2;
        position: absolute;
        top: 53%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all ease .3s;
        opacity: 0;
    }
    .locataion-box .map:hover::after{
        opacity: 1;
    }
    .locataion-box .map:hover .link{
        top: 50%;
        opacity: 1;
    }
}
</style>